import { Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './pages/Login';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Dashboard } from './pages/Dashboard';
import { OrdersList } from './pages/OrdersList';
import { OrderDetail } from './pages/OrderDetail';
import { CustomersList } from './pages/CustomersList';
import { CustomerDetail } from './pages/CustomerDetail';
import { PhotosList } from './pages/PhotosList';
import { PhotoEdit } from './pages/PhotoEdit';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="orders" element={<OrdersList />} />
        <Route path="orders/:uuid" element={<OrderDetail />} />
        <Route path="customers" element={<CustomersList />} />
        <Route path="customers/:uuid" element={<CustomerDetail />} />
        <Route path="photos" element={<PhotosList />} />
        <Route path="photos/new" element={<PhotoEdit />} />
        <Route path="photos/:uuid" element={<PhotoEdit />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
